import { render } from "./MonthlyTrafficLightTable.vue?vue&type=template&id=62948938&scoped=true"
import script from "./MonthlyTrafficLightTable.vue?vue&type=script&lang=js"
export * from "./MonthlyTrafficLightTable.vue?vue&type=script&lang=js"

import "./MonthlyTrafficLightTable.vue?vue&type=style&index=0&id=62948938&lang=sass&scoped=true"
import "./MonthlyTrafficLightTable.vue?vue&type=style&index=1&id=62948938&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62948938"]])

export default __exports__